import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../../shared/icon/icon'
import { useApiFormGroup } from '../../../../../api-new/state/content'
import { Card } from '../../../../../shared/card/card'
import { useRoleOrgGroup } from '../../../../../role/hook/role-org'
import { FormNew } from '../../../../../shared/form-new/form'
import { FormNewText } from '../../../../../shared/form-new/form-text'
import { FormNewButtonCreateBack } from '../../../../../shared/form-new/form-button'

export function GroupAdd() {
  const history = useHistory()

  const apiFormGroup = useApiFormGroup()

  const roleOrgGroup = useRoleOrgGroup()

  const handleSubmit = async data => {
    let group = await apiFormGroup.post(data)
    if (roleOrgGroup.accessUpdate) history.push(`/org/group/list/edit/${group.id}`)
    else history.push(`/org/group/list`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="add">
        <Card title="add group">
          <FormNew enabled={roleOrgGroup.accessCreate} onSubmit={handleSubmit}>
            <FormNewText name="name" autoFocus required />
            <FormNewButtonCreateBack backURL="/org/group/list" />
          </FormNew>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
